import { observer } from 'mobx-react-lite';
import { addLocationTextConsumer } from 'owa-locstrings/lib/strings/addlocationtextconsumer.locstring.json';
import { addLocationText } from 'owa-locstrings/lib/strings/addlocationtext.locstring.json';
import loc from 'owa-localize';
/* tslint:disable:jsx-no-lambda WI:47599 */
import * as React from 'react';
import { getComposeStore } from 'owa-calendar-compose-store-manager';
import LocationCommonWell from 'owa-location-common-well/lib/components/LocationCommonWell';
import getLocationCommonWellItemsFromEnhancedLocation from 'owa-location-common-well/lib/utils/enhancedLocationConversion';
import { DraggableItemTypes } from 'owa-dnd/lib/utils/DraggableItemTypes';
import { getComposeCalendarColorScheme } from 'owa-calendar-compose-form-store/lib/selectors/getComposeCalendarColorScheme';
import { themeFromColorScheme } from 'owa-color-utils/lib/colorUtils';
import {
    addLocationsFromCommonWell,
    removeLocationsFromCommonWell,
} from 'owa-calendar-compose-form-actions';
import { renderLocationFBBadge } from 'owa-calendar-quick-compose-view/lib/utils/renderLocationFBBadge';
import { ThemeProvider } from '@fluentui/react-theme-provider';
import { isConsumer } from 'owa-session-store';
import { populateLocationSuggestions } from 'owa-location-suggestions-cache/lib/utils/populateLocationSuggestions';
import { onLocationSuggestionsStateChanged } from 'owa-location-suggestions-cache/lib/utils/onLocationSuggestionsStateChanged';
import { default as getLocationSuggestionsCache } from 'owa-location-suggestions-cache/lib/store/store';
import generateBorderStyle from 'owa-calendar-forms-common/lib/utils/generateBorderStyle';
import { updateUnresolvedLocation } from 'owa-calendar-compose-form-store/lib/mutators/composeViewStateMutators';
import getQuickComposeViewState from 'owa-calendar-compose-form-store/lib/selectors/getQuickComposeViewState';

let styles = require('./QuickComposeLocationWell.scss');
const classNames = require('classnames/bind').bind(styles);

export interface QuickComposeLocationWellProps {
    isNarrow?: boolean;
}

export default observer(function QuickComposeLocationWell(props: QuickComposeLocationWellProps) {
    React.useEffect(() => {
        // Calling populate the cache for the location well
        const { event } = getComposeStore();
        populateLocationSuggestions(event, 'All' /*search mode of the location well in compose*/);
    }, []);
    const colorScheme = getComposeCalendarColorScheme();
    const { event } = getComposeStore();
    const viewState = getQuickComposeViewState();
    const borderColorStyle = generateBorderStyle(colorScheme);
    const isBusiness = !isConsumer(event.ParentFolderId.mailboxInfo.userIdentity);
    const locationCommonWellPlaceholder = isBusiness
        ? loc(addLocationText)
        : loc(addLocationTextConsumer);
    return (
        <ThemeProvider
            theme={themeFromColorScheme(colorScheme)}
            className={styles.locationCommonWellWrapper}>
            <LocationCommonWell
                containerClassName={classNames(
                    styles.locationCommonWellContainer,
                    borderColorStyle.bottomBorder
                )}
                defaultSelectedItems={getLocationCommonWellItemsFromEnhancedLocation(
                    event.Locations
                )}
                selectedItems={getLocationCommonWellItemsFromEnhancedLocation(event.Locations)}
                draggableItemType={DraggableItemTypes.ReadWriteRecipient}
                dropViewState={null}
                roomFreeBusyEnabled={true}
                event={event}
                theme={themeFromColorScheme(colorScheme)}
                inputProps={{
                    placeholder: event.Locations.length == 0 ? locationCommonWellPlaceholder : '',
                    'aria-label': locationCommonWellPlaceholder,
                }}
                colorScheme={colorScheme}
                onItemsAdded={addLocationsFromCommonWell}
                onItemsRemoved={removeLocationsFromCommonWell}
                onRenderFBBadge={renderLocationFBBadge}
                maxItemWidth={viewState?.viewType == 'TimePanel' || props.isNarrow ? 200 : 380}
                calloutWidth={viewState && viewState.viewType == 'TimePanel' ? 300 : null}
                getPickerState={() => getLocationSuggestionsCache().locationSuggestionsState}
                onPickerStateChanged={onLocationSuggestionsStateChanged}
                onQueryStringChanged={onQueryStringChanged}
                isItemAligned={true}
                canRemoveSuggestion={true}
            />
        </ThemeProvider>
    );
});

function onQueryStringChanged(query: string) {
    updateUnresolvedLocation(query);
}
